import { FlipperPriceBlur } from "@shared/components/FlipperPriceBlur/FlipperPriceBlur";
import { Price } from "@shared/components/Price/Price";

import * as styles from "./PerUnitAmount.styles";

interface Props {
  amount: number;
  promoTotal: number;
}
const PerUnitAmount = ({ amount, promoTotal }: Props) => {
  const renderPrice = () => (
    <FlipperPriceBlur>
      <Price isBold price={amount} isPerUnit />
    </FlipperPriceBlur>
  );

  const renderDiscountedPrice = () => (
    <>
      <div css={styles.strikethrough}>
        <FlipperPriceBlur>
          <Price price={amount} isPerUnit />
        </FlipperPriceBlur>
      </div>
      <FlipperPriceBlur>
        <Price isBold price={amount - Math.abs(promoTotal)} isPerUnit />
      </FlipperPriceBlur>
    </>
  );

  return <div css={styles.container}>{promoTotal ? renderDiscountedPrice() : renderPrice()}</div>;
};

export { PerUnitAmount };
